export default "__VITE_PUBLIC_ASSET__06809125__"